var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn-default",attrs:{"disabled":_vm.disabled,"type":"button"}},_vm.$listeners),[(_vm.isLoading)?_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fas', 'sync-alt'],"spin":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }